'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _requestBuilder = require('./request-builder');

var _requestBuilder2 = _interopRequireDefault(_requestBuilder);

var _errorTypes = require('./error-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FetchJsonClient = function () {
    function FetchJsonClient() {
        _classCallCheck(this, FetchJsonClient);

        this.requestTransformers = [];
    }

    _createClass(FetchJsonClient, [{
        key: 'configure',
        value: function configure(fn) {
            var builder = new _requestBuilder2.default(this);
            fn(builder);
            this.requestTransformers = builder.transformers;
            return this;
        }
    }, {
        key: 'createRequest',
        value: function createRequest(url) {
            var builder = new _requestBuilder2.default(this);
            if (url) {
                builder.withUrl(url);
            }
            return builder;
        }
    }, {
        key: 'get',
        value: function get(url) {
            return this.createRequest(url).asGet().send();
        }
    }, {
        key: 'put',
        value: function put(url, body) {
            return this.createRequest(url).asPut().withBody(body).send();
        }
    }, {
        key: 'post',
        value: function post(url, body) {
            return this.createRequest(url).asPost().withBody(body).send();
        }
    }, {
        key: 'patch',
        value: function patch(url, body) {
            return this.createRequest(url).asPatch().withBody(body).send();
        }
    }, {
        key: 'delete',
        value: function _delete(url, body) {
            return this.createRequest(url).asDelete().withBody(body).send();
        }
    }, {
        key: 'send',
        value: function send(request) {
            return new Promise(function (resolve, reject) {
                fetch(request).then(function (response) {
                    if (response.ok) {
                        return response;
                    } else {
                        // todo: log error
                        throw new _errorTypes.ServerError(response, 'request failed - server error');
                    }
                }).then(function (response) {
                    if (/application\/json/.test(response.headers.get('Content-Type'))) {
                        return new Promise(function (resolve, reject) {
                            response.json().then(function (json) {
                                resolve({ json: json, response: response });
                            }).catch(function (err) {
                                // todo: log error
                                reject(new _errorTypes.FetchResponseError(response, 'request failed - expecting a json response'));
                            });
                        });
                    }
                    return { json: undefined, response: response };
                }).then(function (o) {
                    return resolve(o);
                }).catch(function (err) {
                    if (err instanceof Error) {
                        reject(err);
                    } else {
                        // todo: log error
                        reject(err);
                    }
                });
            });
        }
    }]);

    return FetchJsonClient;
}();

exports.default = FetchJsonClient;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fetch-json-client/dist/lib/fetch-json-client.js
// module id = 644
// module chunks = 0